import React, { useState /*, { useEffect, useState }*/ } from 'react'
import { GET_WEB_CART_STATUS } from '../../requests'
import { history } from '../../store'
import { useInterval } from '../../Utilities/hooks'
import { Spinner } from '../Loaders/Loaders'
// import ComponentUnderConstruction from '../TemporaryPages/UnderConstruction'
// import { useSelector, useDispatch, shallowEqual } from 'react-redux';

const PaymentConfirmation = () => {
  const webCartNum = localStorage.getItem('webCartNum')
  const [waiting, setWaiting] = useState(true)
  const [success, setSuccess] = useState(false)

  useInterval(() => {
    if (waiting) {
      GET_WEB_CART_STATUS(
        webCartNum,
        (response) => {
          console.log(response)
          if (typeof response === 'boolean' && response) {
            localStorage.removeItem('webCartNum')
            history.push(`/receipt?ref=${webCartNum}`)
          }
        },
        (error) => {
          console.error(error)
          setWaiting(false)
          setSuccess(false)
        }
      )
    } else {
      console.error('waiting 3 seconds for cybersource and then try again...')
    }
  }, 3000)

  if (!waiting && !success) {
    return (
      <div>
        <h1 style={{ margin: '32px 32px' }}>
          The payment did not go through, check cart and try again.{' '}
        </h1>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <h1 style={{ margin: '32px 32px' }}>waiting for payment confirmation... </h1>
      <Spinner size="small" linear themeColor="medium-neutral" className="loader" />
    </div>
  )
}

export default PaymentConfirmation
